import { type MediaProvider } from '@atlaskit/editor-common/provider-factory';
import { type AsapClaims } from '@atlassian/asap-interface';
import jwtDecode from 'jwt-decode';

import { currentHostFrameContext } from '@canvas/canvas-state/host-api';

const { mediaCollectionId, mediaToken, mediaBaseUrl } = currentHostFrameContext.data;

// eslint-disable-next-line require-await
const authProvider = async () => {
  return {
    token: mediaToken,
    clientId: jwtDecode<AsapClaims>(mediaToken).iss,
    baseUrl: mediaBaseUrl,
  };
};

export const mediaProps: { provider: Promise<MediaProvider> } = {
  provider: Promise.resolve({
    uploadParams: {
      collection: `contentId-${mediaCollectionId}`,
    },
    viewMediaClientConfig: {
      authProvider,
    },
    uploadMediaClientConfig: {
      authProvider,
      useSha256ForUploads: true,
    },
  }),
};
